<template>
  <div>
    <patient-header />
    <!-- Action buttons section -->
    <section class="container patient-dashboard-actions">
      <div class="row grid-justify-content-right actions" v-if="!patientGegevens.IsArchived">
          <v-button-dropdown v-if="ssoDetails && ssoDetails.length > 0 && !isUserDeviceManager" :options="ssoDetails"
            :buttonProps="{ primary: false, inverted: true, alt: true, md: true, hollow: true }"
            @onSelect="goToCareProgram">
              <icon :is="'medicalBag'" class="patient-dashboard__medicalBag"></icon>
              Zorgprogramma’s
          </v-button-dropdown>
          <v-button v-if="licenseOverviews && licenseOverviews.hasActiveLicenses && !patientGegevens.IsDeceased && !isUserDeviceManager" tagelement="a" md hollow iconLeft @click.native.prevent="$router.push('/catalog')">
            <v-plus-circle-icon title=""></v-plus-circle-icon>
            Nieuwe bestelling
          </v-button>
          <patient-transfer-button v-if="!isUserDeviceManager" :changeUserForPatientTransfer="changeUserForPatientTransferStatus" :showTransferButton="getShowTransferButtonStatus()" @close="closePatientTransfer()"></patient-transfer-button>
          <patient-follow :isFollowing="isFollowed"></patient-follow>
      </div>
    </section>
    <!-- Dashboard section for all user roles excpet device manager role -->
    <section class="container patient-dashboard" v-if="!isUserDeviceManager">
      <!-- Patient transfer/wlz status block-->
      <div class="row" v-if="getTrasferWlzBlockVisibility()">
        <div v-if="wlzStatus" class="row grid-align-center grid-padding callout">
          <div class="col-md-12 patient-dashboard__wlzStatus">
            Deze patiënt heeft een WLZ indicatie ( <a target="_blank" href="https://www.rijksoverheid.nl/onderwerpen/verpleeghuizen-en-zorginstellingen/wet-langdurige-zorg-wlz">Lees hier meer over WLZ </a>). controleert u alstublieft de zwaarte van de indicatie in uw EPD. U kunt in de meeste gevallen gebruik maken van de reguliere aanvraagformulieren. Indien er sprake is van een indicatie met “verblijf én behandeling” dient u de artikelen te bestellen via <a target="_blank" href="http://www.medbis.nl">MedBIS</a> of kunt u, indien beschikbaar, gebruik maken van de “onvergoede” aanvraagformulieren (met een B ervoor).
          </div>
        </div>
        <div v-if="customerSecurityPolicySettings && customerSecurityPolicySettings.transferredFrom.length > 0 && !customerSecurityPolicySettings.isTransferredToDepartment">
          <div class="row grid-align-center grid-padding patient-dashboard__transferStatus callout">
              <div class="col">Deze patiënt is overgedragen aan uw afdeling door {{customerSecurityPolicySettings.transferredFrom[0].user.simpleName}}</div>
          </div>
        </div>
        <div v-if="customerSecurityPolicySettings && customerSecurityPolicySettings.isTransferredToDepartment">
          <div class="row grid-align-center grid-padding patient-dashboard__transferStatus callout">
              <div class="col">Deze patiënt is overgedragen aan afdeling {{customerSecurityPolicySettings.transferredToDepartmentName}}</div>
              <div @click.prevent="showPatientTransferPopUp()">
                <v-edit class="patient-dashboard__transfer__icons"></v-edit>
              </div>
              <div @click.prevent="showDeletePatientTransferPopUp()">
                <v-delete class="patient-dashboard__transfer__icons"></v-delete>
              </div>
          </div>
          <v-overlay-large v-if="showDeletePatientTransfer" :title="'Patiëntenoverdracht intrekken?'" @close="closeOverlay">
            <p>Weet u zeker dat u {{ patientGegevens.Voorletters }} , {{ patientGegevens.Achternaam}} die overgedragen is aan {{ customerSecurityPolicySettings.transferredTo.user.simpleName }} wilt intrekken?</p>
            <div class="row grid-justify-content-right">
              <v-button lg hollow transparent @click.native="closeOverlay">Annuleren</v-button>
              <v-button class="btn btn--primary btn--lg" @click.native="deleteUserOfTransferredCustomer()">Intrekken</v-button>
            </div>
          </v-overlay-large>
        </div>
      </div>
      <!-- Patient licenses details block -->
      <div class="prescription row">
        <div class="col-xs-12 col-md-6">
          <v-heading :level="3">Machtigingen</v-heading>
        </div>
        <div class="col-xs-12 col-md-6" v-if="accountabilities.length > 0 && !patientGegevens.IsDeceased && !patientGegevens.IsArchived">
          <v-button-dropdown
            v-if="accountabilities.length < 6"
            :options="accountabilities"
            :buttonProps="{ hollow: true, md: true, iconLeft: true }"
            @onSelect="goToCreateAccountability"
            class="prescription__button" :id="getDemoId('dropdown')">
            <v-plus-circle-icon title=""></v-plus-circle-icon>Nieuwe machtiging
          </v-button-dropdown>
          <div v-else class="patient-dashboard__newMatching">
            <!-- //-->
            <v-button :id="getDemoId('button')" tagelement="a" md primary hollow iconLeft @click.native.prevent="goToNieuweMachtiging">
              <v-plus-circle-icon title=""></v-plus-circle-icon>
              Nieuwe machtiging
            </v-button>
          </div>
        </div>
        <!--Pop up -->
        <generic-modal v-if="showPopUp">
          <template #header>
            Patiëntinformatie niet compleet
          </template>
          <template #body>
            <p>Niet alle noodzakelijke patiëntinformatie aanwezig, ga naar “Patiëntgegevens wijzigen” om de gegevens aan te vullen</p>
          </template>
          <template #footer>
            <v-button tagelement="button" md primary @click.native="editPatientDetails">Patiëntgegevens wijzigen</v-button>
          </template>
        </generic-modal>
      </div>
      <v-licenses
        v-if="licenseOverviews && licenseOverviews.items.length > 0"
        :isArchived="patientGegevens.IsArchived"
        :licenseOverviews="licenseOverviews.items"
        :enableManagement="true"
        :displayStatusIcon="true"
        :patientId="patientGegevens.PatientId">
      </v-licenses>

      <div class="callout license-helper" :class="{'helper-margin' : addMarginForButton}" v-if="licenseOverviews && !licenseOverviews.hasActiveLicenses">
          <div class="row"><small v-html="licenseOverviews.licenseHelperMessage.subMessage"></small></div>
          {{ licenseOverviews.licenseHelperMessage.message}}
          <mds-navigation-link v-if="licenseOverviews.licenseHelperMessage.title != ''" :title='licenseOverviews.licenseHelperMessage.title' :text='licenseOverviews.licenseHelperMessage.title' current>
						<span slot='submenu'>
							<mds-dropdown data-type='menu'>
								<div slot='content'>
									<mds-navigation-link href="#" @click="departmentChange(item)" :text='item.institutionName + " | " +  item.departmentName + " | " + item.treatmentArea' v-for="item in licenseOverviews.licenseHelperMessage.items" :key="item"></mds-navigation-link>
								</div>
							</mds-dropdown>
						</span>
					</mds-navigation-link>
      </div>
      <!-- Patient ordered history details block -->
      <v-patient-order-history
        :isArchived="patientGegevens.IsArchived"
        :isActiveLicense="licenseOverviews && (licenseOverviews.hasActiveLicenses || licenseOverviews.otherDeptLicense)"
      ></v-patient-order-history>      
      <!-- Patient recently ordered details block -->
      <v-patient-recently-ordered-products
        :isActiveLicense="licenseOverviews && licenseOverviews.hasActiveLicenses"
        :patientId="patientGegevens.PatientId">
      </v-patient-recently-ordered-products>
      <!-- OSA Details block -->
      <v-osa-details
        v-if="isShowOsaSectionFeatureEnabled"
        :osaOverview="osaOverviewDetails"
      ></v-osa-details>
      <!--Patient measurement details based on the portal -->
      <v-patient-measurements
        v-if="patientGegevens.ShowMeasureMoments && !isRespiratory"
      ></v-patient-measurements>
    </section>
    <!-- Dashboard section users with device manager role -->
    <section class="container patient-dashboard" v-else>
      <div class="prescription row">
        <div class="col-xs-12 col-md-6">
          <v-heading :level="3">Apparaten</v-heading>
        </div>
        <div class="col-xs-12 col-md-6 justify-content-end">
          <div>
            <v-button tagelement="a" md cta @click.native.prevent="$router.push('/apparaattoewijzen')">
              Apparaat toewijzen
            </v-button>
          </div>
        </div>
      </div>
      <div class="patient-dashboard__devices">
        <v-table v-if="devices && devices.length > 0">
          <thead>
            <v-header-row :data="deviceHeader" :showSort="false" :page="'Apparatenoverzicht'"></v-header-row>
          </thead>
          <v-device-overview-row
            v-for="(row, index) in devices"
            :data="row"
            :key="index"
            :index="index"
            :overviewStatus="true"
            :patientStatus="true"
            :dashboardStatus="true"
            @retourDevice="retourDeviceManagerEquipments"
            >
          </v-device-overview-row>
        </v-table>
        <div v-else class="row grid-align-center grid-padding callout">
          <div class="col-xs-12">Er is nog geen apparaat aan deze patiënt toegewezen.</div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import store from '@/store'
import router from '@/router'
import axios from 'axios'
import { mapGetters, mapActions } from 'vuex'
import VLicenses from '@/components/sections/licenses/Index'
import VHeaderRow from '@/components/shared/table/rows/HeaderRow'
import PatientTransferButton from '@/components/sections/patientTransfer/PatientTransferButton'
import PatientFollow from '@/components/sections/patient/PatientFollow'
import PatientHeader from '@/components/sections/patient/PatientHeader'
import VPatientRecentlyOrderedProducts from '@/components/sections/patientOrderHistory/PatientRecentlyOrderedProducts'
import VPatientOrderHistory from '@/components/sections/patientOrderHistory/PatientOrderHistory'
import VButtonDropdown from '@/components/shared/ButtonDropdown'
import VPlusCircleIcon from 'icons/PlusCircle'
import VTable from '@/components/shared/table/Table'
import VPatientMeasurements from '@/components/sections/patientMeasurements/PatientMeasurements'
import VOsaDetails from '@/components/sections/osa/osaDetails'
import medicalBag from 'icons/MedicalBag'
import VEdit from 'icons/Pencil'
import VDelete from 'icons/Cancel'
import VOverlayLarge from '@/components/shared/OverlayLarge.vue'
import 'intro.js/minified/introjs.min.css'
import introJs from 'intro.js'
import GenericModal from '@/components/shared/GenericModal'
import { map } from 'rxjs/operators';
import VDeviceOverviewRow from '@/components/sections/devices/deviceOverviewRow'
import { pushDepartmentChangedEvent } from '@/components/sections/navigation/departmentChangedEventStream'

import {
  currentUserIdentity$,
  ccpSsoDetails$,
  customerDeviceManagerEquipments$,
  invalidateCustomerDeviceManagerEquipments$,
  licenseOverviews$,
  customerSecurityPolicySettings$,
  activePpwRecId$,
  activeCustomerId$,
  dispatchCommand,
  navigateToAccountability,
} from '@/services';

export default {
  name: 'v-patientdashboard',
  components: {
    VLicenses,
    VHeaderRow,
    VPatientOrderHistory,
    PatientFollow,
    VButtonDropdown,
    PatientHeader,
    PatientTransferButton,
    VPlusCircleIcon,
    VTable,
    VPatientMeasurements,
    VPatientRecentlyOrderedProducts,
    VEdit,
    VDelete,
    VOverlayLarge,
    medicalBag,
    VOsaDetails,
    GenericModal,
    VDeviceOverviewRow
  },
  subscriptions () {
    return {
      activePpwRecId: activePpwRecId$,
      activeCustomerId: activeCustomerId$,
      customerSecurityPolicySettings: customerSecurityPolicySettings$,
      user: currentUserIdentity$,
      licenseOverviews: licenseOverviews$,
      ssoDetails: ccpSsoDetails$.pipe(
        map(data => {
          if (data === null) {

            return null;
          }

          data.forEach((ssoProgram, index) => {
            ssoProgram.id = index;
            ssoProgram.title = ssoProgram.treatmentArea;
          });
          return data;
        })
      ),
      devices: customerDeviceManagerEquipments$
    };
  },
  data () {
    return {
      filterCountButtonTextOptions: {
        more: 'Toon meer',
        less: 'Toon minder'
      },
      filterCountDefault: 5,
      filterCount: null,
      changeUserForPatientTransferStatus: false,
      showDeletePatientTransfer: false,
      showPopUp: false,
      intro: introJs(),
      deviceHeader: ['', 'Omschrijving', 'Serienummer', 'Locatie', 'Onderhoudsstatus', 'Gepland onderhoud', ''],
      osaOverviewDetails: {}
    }
  },
  computed: {
    ...mapGetters({
      patientGegevens: 'patient/getPatientGegevens',
      accountabilities: 'accountability/getAccountabilities' /* actually templates */,
      isFollowed: 'patient/getPatientFollowStatus',
      wlzStatus: 'patient/getWLZStatus'
    }),
    isUserDeviceManager () {
      return this.user.isDeviceManager;
    },
    transferredTo () {
      return (this.customerSecurityPolicySettings && this.customerSecurityPolicySettings.transferredTo) || null;
    },
    transferredFrom () {
      return (this.customerSecurityPolicySettings && this.customerSecurityPolicySettings.transferredFrom) || [];
    },
    transferredToDepartment () {
      return (this.customerSecurityPolicySettings && this.customerSecurityPolicySettings.isTransferredToDepartment) || false;
    },
    isRespiratory () {
      return store.state.navigation.siteCode === 'MRT';
    },
    addMarginForButton() {
      return this.licenseOverviews && this.licenseOverviews.items.length > this.filterCountDefault;
    },
    isShowOsaSectionFeatureEnabled() {
      return this.licenseOverviews && this.licenseOverviews.hasOsaLicenses && this.$featureFlag.showOsaSectionPatientDashboard;
    }
  },
  created () {
    this.filterCount = this.filterCountDefault
    store.dispatch('patient/getCurrentPatient').then(() => {
      if (!this.isUserDeviceManager) {
        this.loadOsaOverviewDetails()
        store.dispatch('patient/fetchWLZStatus', store.state.patient.patientGegevens.PatientId)
        store.dispatch('accountability/fetchAccountabilities')
        store.dispatch('navigation/fetchResults')
      }
    })
    if (store.state.navigation.demo && store.state.navigation.demoActivated & store.state.navigation.demoFlow.createLicense) {
      setTimeout(() => {
        const self = this
        this.intro.setOptions({
          steps: [
            {element: '#licenseBtn', intro: 'Nu de patiënt is aangemaakt, kunnen we eindelijk beginnen met het echte werk! Om een nieuwe machtiging te maken, klik op deze knop.', position: 'bottom-left-aligned'}
          ],
          exitOnEsc: false,
          exitOnOverlayClick: false,
          skipLabel: 'Overslaan',
          nextLabel: 'Volgende >',
          prevLabel: '< Terug',
          doneLabel: 'Okey, begrepen'
        })
        this.intro.start().onchange(function () {
          self.intro.exit()
        }).oncomplete(function () {
          self.intro.exit()
          router.push('/nieuwemachtiging')
        })
        window.scrollTo(0, 0)
      }, 1500)
    }
  },
  methods: {
    ...mapActions('patient', ['setEndpoints']),
    async loadOsaOverviewDetails () {
      await axios.get('osa/GetOsaOverview').then((response) => {
        if (response && response.data && response.data.Success) {
          this.osaOverviewDetails = response.data.OsaOverview
        }
      })
    },
    /**
     * @function goToCreateAccountability - Redirecting prescirber to create accountability page
     * @param {string} - id
     */
    goToCreateAccountability (id ) {
      let gender = this.patientGegevens.GeslachtId
      let initial = this.patientGegevens.Voorletters
      let lastName = this.patientGegevens.Achternaam
      let dob = this.patientGegevens.GeboorteDatum
      let policy = this.patientGegevens.Verzekering[0].Polisnummer
      let payer = this.patientGegevens.Verzekering[0].Verzekeraar.Id
      let address = this.patientGegevens.WoonAdres.AdresId
      if (gender !== '' && initial !== '' && lastName !== '' && dob !== '' && policy !== '' && payer !== '' && address !== '') {
        store.commit('accountability/setShowExtendLicensesBlock', false)
        store.dispatch('accountability/startNewAccountability', id).then((response) => {
          navigateToAccountability(response.regular.accountabilityId);
        })
      } else {
        this.showPopUp = true
      }
    },
    goToNieuweMachtiging () {
      this.intro.exit()
      this.showPopUp = true
      let gender = this.patientGegevens.GeslachtId
      let initial = this.patientGegevens.Voorletters
      let lastName = this.patientGegevens.Achternaam
      let dob = this.patientGegevens.GeboorteDatum
      let policy = this.patientGegevens.Verzekering[0].Polisnummer
      let payer = this.patientGegevens.Verzekering[0].Verzekeraar.Id
      let address = this.patientGegevens.WoonAdres.AdresId
      if (gender !== '' && initial !== '' && lastName !== '' && dob !== '' && policy !== '' && payer !== '' && address !== '') {
        router.push('/nieuwemachtiging')
      }
    },
    editPatientDetails (e) {
      this.showPopUp = false
      e.preventDefault()
      this.setEndpoints('edit')
      var url = '/patientgegevens'
      router.push(url)
      return false
    },
    goToCareProgram (id) {
      window.open(this.ssoDetails[id].url, '_blank')
    },
    getDemoId (type) {
      if (this.accountabilities.length < 6 && type === 'dropdown') {
        return 'licenseBtn'
      }
      if (this.accountabilities.length >= 6 && type === 'button') {
        return 'licenseBtn'
      }
      return ''
    },
    showPatientTransferPopUp () {
      this.changeUserForPatientTransferStatus = true
    },
    closeOverlay () {
      this.showDeletePatientTransfer = false
    },
    deleteUserOfTransferredCustomer () {
      dispatchCommand("UndoTransferredCustomer", {
        customerId: this.activeCustomerId,
        fromPpwRecId: this.activePpwRecId
      }).then(() => {
        this.closeOverlay();
      });
    },
    showDeletePatientTransferPopUp () {
      this.showDeletePatientTransfer = true
    },
    getTrasferWlzBlockVisibility () {
      return this.wlzStatus || this.transferredTo || this.transferredFrom.length > 0 || this.transferredToDepartment;
    },
    getShowTransferButtonStatus () {
      return !this.transferredTo && this.transferredFrom.length === 0;
    },
    closePatientTransfer () {
      this.changeUserForPatientTransferStatus = false
    },
    /**
     * @function toggleFilterCount
     * @desc Toggles the filter count between null and filterCountDefault
     */
    toggleFilterCount () {
      this.filterCount = this.filterCount ? null : this.filterCountDefault
    },
    retourDeviceManagerEquipments () {
      invalidateCustomerDeviceManagerEquipments$()
    },
    departmentChange (item) {
      store.dispatch('login/selectedDepartmentChange', item.ppwRecId).then((response) => {
        store.dispatch('login/fetchDepartmentResults')
        store.dispatch('navigation/fetchResults')
        pushDepartmentChangedEvent({});
    });

    }
  }
}
</script>

<style lang="scss" scoped>
.main {
  &__view {
    padding: 0px !important;
  }
}
.patient-dashboard-actions {
  @each $breakpoint-key, $breakpoint-value in $grid-breakpoints {
    @include min-screen(grid-breakpoint($breakpoint-key)) {
      padding-top: grid-gutter($breakpoint-key);
    }
  }
  .actions {
    /deep/ .btn {
      margin-left: 10px;
    }
  }
}
.patient-dashboard {
  @each $breakpoint-key, $breakpoint-value in $grid-breakpoints {
    @include min-screen(grid-breakpoint($breakpoint-key)) {
      padding-top: grid-gutter($breakpoint-key);
    }
  }
  &__devices {
    table {
      table-layout: auto !important;
      margin-bottom: 25px;
    }
  }
  p {
    margin-top: 0px !important;
  }
  &__transfer {
    &__icons {
      fill: $teal_darkest;
      margin-right: 8px;
      cursor: pointer;
    }
  }
  &__newMatching {
    position: relative;
    align-self: flex-end;
    z-index: 90;
  }
  .prescription {
    margin-top: 1rem; // remove this later
    &__button {
      @include max-screen(grid-breakpoint(md)) {
        margin-bottom: 1rem;
        align-self: flex-start;
      }
      @include min-screen(grid-breakpoint(md)) {
        align-self: flex-end;
      }
    }
  }
  .error-message {
    color: $red;
    font-weight: 700;
  }
  .callout {
    @each $breakpoint-key, $breakpoint-value in $grid-breakpoints {
      @include min-screen(grid-breakpoint($breakpoint-key)) {
        padding-top: grid-gutter($breakpoint-key);
        padding-bottom: grid-gutter($breakpoint-key);
        margin-bottom: grid-gutter($breakpoint-key);
      }
    }

    background-color: $teal-lighter;
    justify-content: space-between
  }

  .license-helper{
    padding-left: 24px;
    padding-right: 24px;
    small {
      color: #006983;
      a {
        color: $teal-darkest;
        text-decoration: underline;
        cursor: pointer;
      }
    }
  }

  &__medicalBag {
    margin: 0px 10px 0px 0px;
  }
  &__wlzStatus {
    display: inline;
    border-radius: 3px;
    a {
      color: $teal-darkest;
      text-decoration: underline;
      cursor: pointer;
    }
  }
  &__transferStatus {
    border-radius: 3px;
    background-color: $white !important;
    border: solid 1px $gray-light;
  }

  .helper-margin {
    margin-top: 24px;
  }
}
</style>
